import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./plugins/vue-apexcharts";
import "./filters/round";
import "./filters/displayDate";
import DataService from "@/services/data-service/data-service";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

const myDataService = new DataService();
Vue.config.productionTip = false;
Vue.prototype.$dataService = myDataService;
const myVue = new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");

defineCustomElements(window).then(() => console.log("WPA Custom Elements Registered."));
